require('intersection-observer');
IntersectionObserver.prototype.POLL_INTERVAL = 100;

import './bootstrap';
import Alpine from 'alpinejs'
window.Alpine = Alpine
Alpine.start()

import 'add-to-calendar-button';

AOS.init();

$('#gallery').slick({
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 5,
    dots: true,

    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                infinite: true,
                dots: true
            }
        },
    ]
});

$('#trade-gallery').slick({
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 5,
    dots: true,

    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                infinite: true,
                dots: true
            }
        },
    ]
});

$(document).ready(function () {
    $('.stall-item').on('click', function (e) {
        e.preventDefault();
        var t = $('#contact-form').offset().top;
        $('body,html').animate({
            scrollTop: t,
        });
    })
})


